<template>
  <div class="container">
    <div class="search" style="display:flex">
      <el-form ref="form" style="flex:1" :inline="true" :model="search" class="demo-form-inline">
        <el-form-item>
          <el-select clearable @change="Search" placeholder="app 编号" v-model="search.client_app_code">
            <el-option
              v-for="item in applist"
              :key="item.code"
              :label="item.name"
              :value="item.code">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div>
        <router-link :to="'/iot/app/getuiadd/'+0">
          <el-button type="primary" size="small">新建</el-button>
        </router-link>
      </div>
    </div>
    <!-- 列表 -->
    <el-table border v-bind:data="list">
      <!-- <el-table-column label="序号" type="index" width="50"></el-table-column> -->
      <el-table-column label="app编号">
        <template v-slot="scope">
          <span>{{ appNameCode[scope.row.client_app_code] }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="个推AppSecret">
        <template v-slot="scope">
          <span>{{ scope.row.app_secret }}</span>
        </template>
      </el-table-column>
      <el-table-column label="个推MasterSecret">
        <template v-slot="scope">
          <span>{{ scope.row.master_secret }}</span>
        </template>
      </el-table-column> -->
      <el-table-column label="个推AppKey">
        <template v-slot="scope">
          <span>{{ scope.row.app_key }}</span>
        </template>
      </el-table-column>
      <el-table-column label="个推APPID">
        <template v-slot="scope">
          <span>{{ scope.row.app_appid }}</span>
        </template>
      </el-table-column>
      <el-table-column label="推送消息title">
        <template v-slot="scope">
          <span>{{ scope.row.title }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Alert显示消息内容">
        <template v-slot="scope">
          <span>{{ scope.row.msg }}</span>
        </template>
      </el-table-column>
      <el-table-column label="APP应用包名">
        <template v-slot="scope">
          <span>{{ scope.row.package_name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="250px">
        <template v-slot="scope">
          <router-link style="margin-right:10px" :to="'/iot/app/getuiadd/'+scope.row.id">
            <el-button type="primary" size="small">修改</el-button>
          </router-link>
          <el-button type="danger" size="small" @click="deleteFcm(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @current-change="handleCurrentChange"
      v-model:currentPage="search.page"
      :page-size="search.limit"
      layout="total, prev, pager, next"
      :total="total">
    </el-pagination>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  name: '',
  mixins: [],
  components: {},
  props: {},
  data () {
    return {
      search: {
        page: 1,
        limit: 10,
        client_app_code: ''
      },
      list: [],
      total: 0,
      applist: [],
      appNameCode: {}
    }
  },
  computed: {},
  watch: {},
  methods: {
    handleCurrentChange(val) {
      this.search.page = val
      this.Search()
    },
    GetappCode() {
        this.api.ClientList({
            page: 1,
            limit: 100
        }).then(res => {
        if (res.data.code == 200) {
          this.applist = res.data.data.data
          res.data.data.data.forEach(item => {
            this.appNameCode[item.code] = item.name
          })
          return
        }
        this.$message.error('获取失败' + res.data.msg)
      })
    },
    Search() {
      this.api.GetuiList(this.search).then(res => {
        if (res.data.code == 200) {
          this.list = res.data.data.data
          this.total = res.data.data.page_info.total
          return
        }
        this.$message.error('获取失败' + res.data.msg)
      })
    },
    deleteFcm(item) {
      this.$confirm('是否删除该个推推送?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 删除请求
        this.api.GetuiDelete({id: item}).then(res => {
          if (res.data.code == 200) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
            this.Search()
            return
          }
          this.$message.error('删除失败' + res.data.msg)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消删除'
        });
      })
    },
  },
  filters: {},
  mounted () {
    this.Search()
  },
  created () {
    this.GetappCode()
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
</style>
